import { render, staticRenderFns } from "./ContentReportModal.vue?vue&type=template&id=cb166d54&scoped=true&"
import script from "./ContentReportModal.vue?vue&type=script&lang=js&"
export * from "./ContentReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb166d54",
  null
  
)

export default component.exports